<template>
  <div class="userDetails commonWrap">
    <el-page-header
      style="padding: 10px 0 0 20px"
      @back="$parent.showMinaPage = false"
      content="用户详情"
    >
    </el-page-header>
    <div class="userMSG">
      <div class="userLeft">
        <h5>{{ userInfo.name }}</h5>
        <p>部门: {{ userInfo.departmentName }}</p>
        <p>电话: {{ userInfo.phone }}</p>
        <p>最近登录时间: {{ userInfo.latestLoginTime }}</p>
      </div>
      <div class="userMiddle ashComWrap">
        <div class="comTitle">
          <el-radio-group
            v-model="timeType"
            size="mini"
            style="margin: 0 auto"
            @change="getChartsData"
          >
            <el-radio-button label="MONTH">本月</el-radio-button>
            <el-radio-button label="YEAR">本年</el-radio-button>
            <el-radio-button label="">全部</el-radio-button>
          </el-radio-group>
        </div>
        <div class="comContentBox">
          <PublicEcharts
            :id="'userMiddle'"
            :chartsData="regionList"
            :type="'ringChart'"
          />
        </div>
      </div>
    </div>
    <div class="tabContent">
      <PlabAndRecord />
    </div>
  </div>
</template>

<script>
import api from "@/api";
import { dateFtt } from "@/assets/js/utils";
import PublicEcharts from "@/components/PublicEcharts";
import PlabAndRecord from "./PlabAndRecord";
export default {
  components: {
    PublicEcharts,
    PlabAndRecord,
  },
  data() {
    return {
      timeType: "MONTH",
      regionList: { unit: "", dataArr: [] }, //区域
      activeUser: {},
      userInfo: {},
    };
  },
  methods: {
    async getChartsData() {
      this.regionList.dataArr = [];
      let res = await api.authorityGetUserTolCharts({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        key: "UserPlans",
        dateType: this.timeType,
        userId: this.activeUser.id,
      });
      if (res && res.data.code == 200) {
        this.regionList.dataArr = res.data.data;
      }
    },
    async getDepartmentByUserId() {
      let res = await api.projectGetDepartmentByUserId({
        userId: this.activeUser.id,
      });
      if (res && res.data.code == 200) {
        this.getUserInfo(res.data.data.id);
      }
    },
    async getUserInfo(departmentId) {
      let res = await api.projectGetUserInfoByUserId({
        departmentId,
        userId: this.activeUser.id,
      });
      // console.log("userInfo", res);
      if (res && res.data.code == 200) {
        this.userInfo = res.data.data;
        this.userInfo.latestLoginTime =
          this.userInfo.latestLoginTime && this.userInfo.latestLoginTime != 0
            ? dateFtt(
                "yyyy-MM-dd hh:mm",
                new Date(this.userInfo.latestLoginTime)
              )
            : "-";
      }
    },
  },
  created() {
    this.activeUser = this.$store.state.user.activeUser;
    if (this.activeUser.id) {
      this.getChartsData();
      this.getDepartmentByUserId();
    }
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.userDetails {
  @include setCenterWH;
  ::v-deep .el-tabs__nav-wrap::after {
    background-color: transparent;
  }
  .userMSG {
    width: 98%;
    height: 30%;
    margin: 10px auto;
    @include setFlexStart;
    .userLeft {
      width: 33%;
      height: 100%;
      padding-left: 30px;
      @include setFlexColumn;
      justify-content: space-between;
      h5 {
        font-size: 28px;
        margin-top: 20px;
      }
      p {
        margin: 15px 0;
      }
    }
    .userMiddle {
      width: 30%;
      height: 100%;
    }
  }
  .tabContent {
    width: 98%;
    height: 62%;
    margin: 0 auto;
  }
}
</style>
